module.exports = __webpack_public_path__ + "static/media/3-minute-meditation.0f2b763f.wav";